<script lang="ts" setup>
// ================================
// IMPORTS
// ================================
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { formatDate } from "@core/helpers"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            title: "Derniers paramètres utilisés",
            period: "Période d'analyse : du {startDate} au {endDate}",
            temp_utilisation:
                "Température de consigne en période de présence : {temp} °C",
            temp_no_utilisation:
                "Température de consigne en période d'absence : {temp} °C",
        },
    },
})

// ================================
// PROPS & EMITS
// ================================
const props = withDefaults(
    defineProps<{
        /**
         * Titre du bloc (défaut : clé i18n iot_last_param_used.title)
         */
        title?: string
        /**
         * Date de début de la période d'analyse (format YYYY-MM-DD)
         */
        dateFrom: string
        /**
         * Date de fin de la période d'analyse (format YYYY-MM-DD)
         */
        dateTo: string
        /**
         * Température de consigne en période de présence (°C)
         */
        temperatureUtilisation?: number | null
        /**
         * Température de consigne en période d'absence (°C)
         */
        temperatureNonutilisation?: number | null
    }>(),
    {
        title: undefined,
        temperatureUtilisation: null,
        temperatureNonutilisation: null,
    }
)

const displayTitle = computed(() => props.title ?? t("title"))
</script>

<template>
    <BaseCard class="analyse-temp-ambiance-last-params">
        <template #title>
            {{ displayTitle }}
        </template>
        <template #content>
            <!-- Période -->
            <p>
                {{
                    t("period", {
                        startDate: formatDate(dateFrom),
                        endDate: formatDate(dateTo),
                    })
                }}
            </p>
            <!-- Consigne de température en cas de présence -->
            <p v-if="temperatureUtilisation != null">
                {{
                    t("temp_utilisation", {
                        temp: temperatureUtilisation,
                    })
                }}
            </p>
            <!-- Consigne de température en cas d'absence -->
            <p v-if="temperatureNonutilisation != null">
                {{
                    t("temp_no_utilisation", {
                        temp: temperatureNonutilisation,
                    })
                }}
            </p>
        </template>
    </BaseCard>
</template>
